// Material UI
import { Grid, Chip, Icon } from '@mui/material';
import { Facebook, X, Instagram } from '@mui/icons-material';
import { FaTiktok } from 'react-icons/fa';

// Componentes
import TextFieldTK from '@components/Form/TextFieldTK';

// Utils
import { getFormikUtil } from '@utils/Utilities';

const SocialMediaForm = (props) => {
  const { isLoading, formik, showChip = true } = props;

  const getFormik = (value) => getFormikUtil(formik, 'social', value);

  return (
    <Grid container spacing={3}>
      {showChip && (
        <Grid item xs={12}>
          <Chip icon={<Icon>groups</Icon>} label="Redes Sociales" />
        </Grid>
      )}

      <Grid item xs={12} md={6}>
        <TextFieldTK
          fullWidth
          name="social.facebook"
          label="Facebook"
          placeholder="usuario"
          usePlaceholder="https://www.facebook.com/"
          value={getFormik('facebook')?.value}
          onChange={formik.handleChange}
          disabled={isLoading}
          error={getFormik('facebook')?.error}
          helperText={getFormik('facebook')?.helperText}
          icon={{ icon: <Facebook /> }}
          noSpaces
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextFieldTK
          fullWidth
          name="social.x"
          label="X"
          placeholder="usuario"
          usePlaceholder="https://x.com/"
          value={getFormik('x')?.value}
          onChange={formik.handleChange}
          disabled={isLoading}
          error={getFormik('x')?.error}
          helperText={getFormik('x')?.helperText}
          icon={{ icon: <X /> }}
          noSpaces
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextFieldTK
          fullWidth
          name="social.instagram"
          label="Instagram"
          placeholder="usuario"
          usePlaceholder="https://www.instagram.com/"
          value={getFormik('instagram')?.value}
          onChange={formik.handleChange}
          disabled={isLoading}
          error={getFormik('instagram')?.error}
          helperText={getFormik('instagram')?.helperText}
          icon={{ icon: <Instagram /> }}
          noSpaces
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <TextFieldTK
          fullWidth
          name="social.tiktok"
          label="TikTok"
          placeholder="usuario"
          usePlaceholder="https://www.tiktok.com/@"
          value={getFormik('tiktok')?.value}
          onChange={formik.handleChange}
          disabled={isLoading}
          error={getFormik('tiktok')?.error}
          helperText={getFormik('tiktok')?.helperText}
          icon={{ icon: <FaTiktok /> }}
          noSpaces
        />
      </Grid>
    </Grid>
  );
};

export default SocialMediaForm;
